import React from 'react';

import styles from './PrettyJson.scss';
import SectionHeader from 'Components/SectionHeader';

class PrettyJson extends React.Component {
  constructor(props) {
    super(props);

    this.prettifyJson = this.prettifyJson.bind(this);
  }

  prettifyJson() {
    if (!this.props.stats) return null;
    return JSON.stringify(this.props.stats, null, '  ');
  }

  render() {
    return (
      <div className="PrettyJson">
        <SectionHeader title={this.props.endpoint} />
        <pre>
          <code>{this.prettifyJson()}</code>
        </pre>
      </div>
    );
  }
}

export default PrettyJson;
